/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';

export const CopyButtonContainer = styled.default.div`
  display: flex;
  align-items: center;
`;